<script setup>
import {useHeadService} from '~/composables/useHeadService';
import {safeRedirectPath} from '~/composables/useSafeRedirect';
import {ref, computed, watch, onMounted, defineAsyncComponent} from 'vue';
import LoginForm from "~/components/auth/LoginForm.vue";
import RegisterForm from "~/components/auth/RegisterForm.vue";
import AuthCard from "~/components/auth/AuthCard.vue";

// Dev-only test account quick sign-in. The literal import.meta.dev is replaced
// with false in a production build, so the import (and with it the account
// list and the password) is dropped from the bundle entirely.
const QuickSignInEntry = import.meta.dev ? defineAsyncComponent(() => import('~/debug/QuickSignInEntry.vue')) : null;

definePageMeta({
  name: 'Login',
  path: '/:authType',
  validate({params}) {
    return params.authType === 'login' || params.authType === 'register';
  }
});

const route = useRoute();
const router = useRouter();
const authType = ref(route.params.authType);
watch(() => route.params.authType, (value) => {
  authType.value = value;
});

const {setMeta} = useHeadService();
setMeta(
    authType.value === 'login' ? 'Sign In to Tap Leagues' : 'Register for Tap Leagues',
    'Home page'
);
const redirectUrl = safeRedirectPath(route.query.redirectUrl);
const tab = computed({
  get() {
    return authType.value;
  },
  set(val) {
    if (val === authType.value) return;
    // keep redirectUrl / authRestricted when hopping between the tabs
    router.replace({path: val === 'register' ? '/register' : '/login', query: route.query}).catch(() => {
    });
  }
});
const {setAlertMessage} = useAlertService();
onMounted(() => {
  if (route.query.authRestricted) {
    setAlertMessage('You need to sign in to access this page');
  }
})
</script>
<template>
  <base-page>
    <v-container class="auth-page">
      <auth-card>
        <v-window class="w-100" v-model="tab">
          <v-window-item value="login">
            <login-form :redirectUrl="redirectUrl"/>
            <component :is="QuickSignInEntry" v-if="QuickSignInEntry" :redirect-url="redirectUrl"/>
          </v-window-item>
          <v-window-item value="register">
            <register-form :redirectUrl="redirectUrl"/>
          </v-window-item>
        </v-window>
      </auth-card>
    </v-container>
  </base-page>
</template>

<style scoped lang="scss">
/* card look comes from the shared auth primitives in components/auth/AuthCard.vue */
</style>
